import React from 'react'
import { Typography } from '@telavita-core/react-design-kit'

import { SelectOptionBannerStateProps } from './types'

import { ReactComponent as CloseIcon } from 'static/svg/icon-close.svg'

import * as S from './styles'

export const SelectSMSBannerState: React.FC<SelectOptionBannerStateProps> = ({ handleCloseBanner }) => (
  <S.ContentSelectedWrapper>
    <S.Content>
      <Typography variant="content2">
        Continuaremos a enviar lembretes das suas próximas consultas por SMS.
      </Typography>
      <Typography variant="content2">
        Caso queira modificar, é só acessar a opção <strong>Configurações</strong> no menu.
      </Typography>
    </S.Content>

    <CloseIcon width={24} height={24} role="button" onClick={handleCloseBanner} />
  </S.ContentSelectedWrapper>
)